import { Card, CardBody, Col } from "reactstrap";
import { WeeklyUserActivityTitle } from "../../../../constants";
import ReactApexChart from "react-apexcharts";
import { UserActivity } from "../../../../data/general/dashboard/ECommerce";
import { CustomerGrowthProp } from "../../../../types/General";
import DashboardHeader from "../common/DashboardHeader";

const WeeklyUserActivity: React.FC<CustomerGrowthProp> = ({ colClass }) => {
  return (
    <Col xxl="4" className={`proorder-xl-6 ${colClass}`}>
      <Card>
        <DashboardHeader title={WeeklyUserActivityTitle} dropdownClass="setting-menu" dropdownToggleClass="dropdown-toggle" />
        <CardBody className="pt-0">
          <div className="user-activity" id="UserActivity">
            <ReactApexChart options={UserActivity} series={UserActivity.series} type="radialBar" height={310} />
          </div>
          <div className="user-activity">
            <ul>
              <li>
                <div className="applications-menu">
                  <div className="rounded-btn-primary" />
                  <h3>Online Applications</h3>
                </div>
                <h4>55%</h4>
              </li>
              <li>
                <div className="applications-menu">
                  <div className="rounded-btn-secondary" />
                  <h3>Offline Applications</h3>
                </div>
                <h4>45%</h4>
              </li>
            </ul>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WeeklyUserActivity;
